export function parseStringToStringArray(text: string) {
  return text
    .split(',')
    .map((text) => text.trim())
    .filter(Boolean);
}
